/**
 * The apps that may use Cloud's `/picker` and `/bridge`, and where each lives
 * beside each Cloud host.
 *
 * One fixed map, read by the picker's gate, by the bridge's gate and by the
 * Worker's `frame-ancestors` for `/bridge`. Never a parameter: a page that
 * posts or answers wherever its address says is a page that serves any site
 * able to open or frame it. Pure data, so the Worker can import it.
 */

const CLIENTS = new Map<string, ReadonlyMap<string, string>>([
  [
    'relay',
    new Map([
      ['cloud.mauvely.com', 'https://relay.mauvely.com'],
      ['cloud.mauvely.dev', 'https://relay.mauvely.dev'],
      // Relay's `npm run dev:web`. Cloud is on 8788 beside it.
      ['localhost', 'http://localhost:8796'],
      ['127.0.0.1', 'http://127.0.0.1:8796']
    ])
  ]
]);

/** The origin of `client` beside this Cloud host, or undefined for either unknown. */
export const clientOrigin = (client: string, hostname: string): string | undefined =>
  CLIENTS.get(client)?.get(hostname);
